import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {

  /**
   * Detect user language using navigator.
   * @param allowedLanguages a list of allowed lanuage codes. Defaults to ['en', 'nl', 'fr']
   * @returns language code for user's preferred language
   */
  detectLanguage(allowedLanguages: string[] = ['en', 'nl', 'fr']): string {
    const browserLang = navigator.language || navigator.languages[0] || 'en';
    const preferredLanguage = browserLang.split('-')[0];
    return preferredLanguage in allowedLanguages ? preferredLanguage : allowedLanguages[0]; // Extract 'en' from 'en-US'
  }
}
